export default "__VITE_ASSET__Dl4$oLeS__"